import { Link } from "react-router-dom";
import { MoodPill, EmotionTag } from "@/components/MoodTag";
import { CalendarBlank } from "@phosphor-icons/react";

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

function fmtDuration(sec) {
  if (!sec) return "";
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
}

export default function EntryCard({ entry }) {
  return (
    <Link
      to={`/entry/${entry.entry_id}`}
      className="card card-hover block p-6"
      data-testid={`entry-card-${entry.entry_id}`}
    >
      <div className="flex items-center justify-between mb-3 text-xs text-ink-500">
        <span className="flex items-center gap-1.5">
          <CalendarBlank size={14} />
          {formatDate(entry.created_at)}
        </span>
        {entry.duration_sec ? <span>{fmtDuration(entry.duration_sec)}</span> : null}
      </div>
      <p className="font-serif text-ink-900 text-lg leading-relaxed line-clamp-3">
        {entry.transcript}
      </p>
      <div className="mt-5 flex flex-wrap gap-2 items-center">
        <MoodPill mood={entry.mood} score={entry.sentiment_score} />
        {(entry.emotion_tags || []).slice(0, 4).map((t) => (
          <EmotionTag key={t} tag={t} />
        ))}
      </div>
    </Link>
  );
}
